export { default as SectionalHeading } from './SectionalHeading';
